import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles.css';
import './i18n';

// Ensure dark mode is applied immediately
document.body.classList.add('dark');

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

try {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error('[main.tsx] RENDER ERROR:', error);
  rootElement.innerHTML = `
    <div style="padding: 40px; color: red; background: #000; font-family: monospace; font-size: 16px;">
      <h1>RENDER ERROR</h1>
      <pre>${error instanceof Error ? error.message : String(error)}</pre>
      <pre style="font-size: 12px; overflow: auto;">${error instanceof Error ? error.stack : ''}</pre>
    </div>
  `;
}





